export default "__VITE_ASSET__Bsi6H8WI__"